/**
 * @file   src\components\AddWashSuccessModal.tsx
 * @brief  Success Modal component.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import { Modal, Button, useNavigate } from '../utils/thirdpartyComponents';
import Successicon from "../assets/images/success-icon.svg";
import '../components/CWModal.scss';
import { pageURLs } from '../utils/pageUrls';

// Toast object creation.

const AddWashSuccessModal = (props: any) => {
  const { show, onHide, carwashid } = props;
  const navigate = useNavigate()

  const handleOnHide = () => {
    navigate(`/superadmin/${pageURLs.signup_process}/${carwashid}`)

    // To clear values saved in bank information, can be removed later
    localStorage.removeItem('bankInformation');
    onHide();
  }

  return (
    <Modal show={show} onHide={handleOnHide} centered className='success-modal'>
      <Modal.Body className='text-center'>
        <div className="icon"><img src={Successicon} alt="Car Wash App" /></div>
        <h4 className='f-bold'>You've added a Car Wash successfully!</h4>
        <p className='f-medium mx-auto'>For a quick start, click 'Proceed To Setup' and add Car Wash
          locations, add bank info, personalize app theme and order hardware.</p>
        <Button title="Proceed To Setup" variant="primary" className='primary-btn' onClick={handleOnHide}>Proceed To Setup</Button>
      </Modal.Body>
    </Modal>
  );
};
export default AddWashSuccessModal;
